import { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
// import toast from "react-hot-toast";

import PageBreadcrumb from "../../../components/common/PageBreadCrumb";
import ComponentCard from "../../../components/common/ComponentCard";
import Badge from "../../../components/ui/badge/Badge"

import {
  Table,
  TableBody,
  TableCell,
  TableHeader,
  TableRow,
} from "../../../components/ui/table";
import authorizedApi from "../../../api/axiosAuthorizedInstance";

export default function AllRegistrations() {
  const [sessions, setSessions] = useState([]);
  const apiUrl = import.meta.env.VITE_API_URL;
  const contentUrl = import.meta.env.VITE_CONTENT_URL;

  useEffect(() => {
    const fetchData = async () => {
      // try {
      //   const response = await authorizedApi.get(apiUrl + "/api/v1/sessions/completed");
      //   if (!response.ok) {
      //     throw new Error(`HTTP error! status: ${response.status}`);
      //   }
      //   const result = await response.json();
      //   setSessions(result);
      // } catch (error) {
      //   console.log(error)
      //   toast.error("Error fetching data");
      // }

      authorizedApi.get(apiUrl + "/api/v1/sessions/completed")
  .then(response => {
    setSessions(response.data);
  });
  // .catch(error => {
  //   console.error("Error fetching data:", error);
  //   toast.error("Error fetching data");
  // });
    };
    fetchData();
  }, []);

  return (
    <>
      <Helmet>
        <title>Completed Registrations</title>
      </Helmet>

      <PageBreadcrumb pageTitle="Completed Registrations" />
      <div className="space-y-6">
        <ComponentCard>
          <div className="overflow-hidden rounded-xl border border-gray-200 bg-white dark:border-white/[0.05] dark:bg-white/[0.03]">
            <div className="max-w-full overflow-x-auto">
              <Table>
                <TableHeader className="border-b border-gray-100 dark:border-white/[0.05]">
                  <TableRow>
                    <TableCell
                      isHeader
                      className="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400"
                    >
                      Customer
                    </TableCell>
                    <TableCell
                      isHeader
                      className="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400"
                    >
                      Email
                    </TableCell>
                    <TableCell
                      isHeader
                      className="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400"
                    >
                      Mobile
                    </TableCell>
                    <TableCell
                      isHeader
                      className="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400"
                    >
                      ID Number
                    </TableCell>
                    <TableCell
                      isHeader
                      className="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400"
                    >
                      Status
                    </TableCell>
                    <TableCell
                      isHeader
                      className="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400"
                    ></TableCell>
                  </TableRow>
                </TableHeader>

                <TableBody className="divide-y divide-gray-100 dark:divide-white/[0.05]">
                  {sessions.map((session) => (
                    <TableRow key={session.id}>
                      <TableCell className="px-5 py-4 sm:px-6 text-start">
                        <div className="flex items-center gap-3">
                          <div className="w-10 h-10 overflow-hidden rounded-full">
                            <img
                              width={40}
                              height={40}
                              src={contentUrl + session.imageUrl}
                              alt="Image"
                            />
                          </div>
                          <div>
                            <span className="block font-medium text-gray-800 text-theme-sm dark:text-white/90">
                              {session.firstName}
                            </span>
                            <span className="block text-gray-500 text-theme-xs dark:text-gray-400">
                              {session.LastName}
                            </span>
                          </div>
                        </div>
                      </TableCell>
                      <TableCell className="px-4 py-3 text-gray-500 text-start text-theme-sm dark:text-gray-400">
                        {session.email}
                      </TableCell>
                      <TableCell className="px-4 py-3 text-gray-500 text-start text-theme-sm dark:text-gray-400">
                        {session.mobile}
                      </TableCell>
                      <TableCell className="px-4 py-3 text-gray-500 text-start text-theme-sm dark:text-gray-400">
                        {session.idNumber}
                      </TableCell>
                      <TableCell className="px-4 py-3 text-gray-500 text-start text-theme-sm dark:text-gray-400">
                        <Badge size="sm" color="warning">In Review</Badge>
                      </TableCell>
                      <TableCell className="px-4 py-3 text-gray-500 text-start text-theme-sm dark:text-gray-400">
                        <Link to={`${session.sessionId}/detail`} className="mt-3 inline-block text-sm font-medium text-gray-500 underline dark:text-gray-400">
                        Detail
                        </Link>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </div>
          </div>
        </ComponentCard>
      </div>
    </>
  );
}
